import React from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

const ScrollProgress = () => {
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);

  if (reduceMotion) {
    return null;
  }

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-0.5 bg-[#00c8ff]/80 origin-left z-[99999] pointer-events-none"
      style={{ scaleX }}
      aria-hidden
    />
  );
};

export default ScrollProgress;
